/**
 * Created by Ning Jiang on 10/4/2018.
 */

import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {TombstoneGameMode} from "../gamemode/TombstoneGameMode";
import {ITombstoneParsedServerData} from "../server/data/ITombstoneParsedServerData";
import {TombstoneWildSymbol} from "../symbols/TombstoneWildSymbol";
import {TombstoneSoundConfig} from "../TombstoneSoundConfig";
import {TombstoneMultiplierView} from "./TombstoneMultiplierView";
import {TombstoneNoMercy} from "../TombstoneNoMercy";
import {TombstoneGameModuleConfig} from "../TombstoneGameModuleConfig";

export class TombstoneMultiplierController extends BaseController {

    public static ADD_MULTIPLIER:string = "tombstoneMultiplierEvent_addMultiplier";
    public static SHOW_END_MULTIPLIER:string = "tombstoneMultiplierEvent_showEndMultiplier";

    private _nextMode:string;
    private _overlayWilds:boolean[][] | undefined;

    private _currentMultiplier:number = 0;
    private _endMultiplier:number;
    private _multiplierOnReel:number[];

    private _view:TombstoneMultiplierView;

    constructor() {
        super();
        this._view = new TombstoneMultiplierView();

        this.addEventListeners();
    }

    private addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_RESTORE, (event:GameEvent) => this.onRestore());
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onBeforeSpinStart());

        EventHandler.addEventListener(this, TombstoneMultiplierController.ADD_MULTIPLIER, (event:GameEvent) => this.onAddMultiplier());
        EventHandler.addEventListener(this, TombstoneMultiplierController.SHOW_END_MULTIPLIER, (event:GameEvent) => this.onShowEndMultiplier(event.params[0]));
    }

    private onDataParsed(data:ITombstoneParsedServerData):void {
        this._nextMode = data.nextMode;
        this._overlayWilds = data.overlayWilds;
        this._endMultiplier = data.currentMultiplier;
        this._multiplierOnReel = data.multiplierOnReel;
    }

    private onRestore():void {
        // Restore Wild symbol multiplier
        if(this._nextMode === TombstoneGameMode.SUPER_FREESPIN && this._overlayWilds != null) {
            this._overlayWilds.forEach((reelOverlay:boolean[], reelId:number) => {
                if(reelOverlay[0]) {
                    const wild:TombstoneWildSymbol = <TombstoneWildSymbol>Reels.getSymbol(reelId, 0);
                    if(wild) {
                        (<TombstoneWildSymbol[]>wild.stack!.symbols).forEach((symbol:TombstoneWildSymbol) => {
                            symbol.updateMultiplier(this._multiplierOnReel[reelId], false);
                        });
                    }
                }
            });
        }

        // Restore total multiplier.
        if(this._nextMode === GameMode.FREESPIN || this._nextMode === TombstoneGameMode.SUPER_FREESPIN) {
            this.updateMultiplier(this._endMultiplier, false);
        }
    }

    private onBeforeSpinStart():void {
        // Reset in normal, respin. when winning freespin/super freespin, there is no wild so no multiplier.
        if(this._nextMode === GameMode.NORMAL || this._nextMode === GameMode.RESPIN) {
            this.abortMultiplier();
        }

        if(TombstoneGameModuleConfig.initData.isRestoreFeatureBet && TombstoneGameModuleConfig.initData.isWinBelowStake()) {
            TombstoneNoMercy.keypad.setWin(TombstoneGameModuleConfig.initData.accumulatedRoundWin, true, TombstoneGameModuleConfig.initData.isWinBelowStake());
            TombstoneGameModuleConfig.initData.isRestoreFeatureBet = false;

        }
    }

    private abortMultiplier():void {
        if(this._endMultiplier > 1 && this._currentMultiplier != this._endMultiplier) {
            this.onShowEndMultiplier(true);
        }

        this._currentMultiplier = 0;
        this._view.hideMultiplier();
    }

    private updateMultiplier(number:number, animate:boolean):void {
        this._currentMultiplier = number;
        const displayNumber:number = this._currentMultiplier === 0 ? 1 : this._currentMultiplier;
        this._view.showMultiplier(displayNumber, animate);
        if(animate) {
            SlotGame.sound.playEffect(this.getMultiplierSound(number));
        }
    }

    private getMultiplierSound(number:number):string {
        switch(number) {
            case 1:
                return TombstoneSoundConfig.instance.MULTIPLIER1;
            case 2:
                return TombstoneSoundConfig.instance.MULTIPLIER2;
            default:
                return TombstoneSoundConfig.instance.MULTIPLIER3;
        }
    }

    private onAddMultiplier():void {
        this._currentMultiplier++;
        this.updateMultiplier(this._currentMultiplier, true);
    }

    private onShowEndMultiplier(animate:boolean):void {
        this.updateMultiplier(this._endMultiplier, animate);
    }
}